// extracted by mini-css-extract-plugin
export default {"aboutContainer":"AboutComp_aboutContainer__ryA2Q","divButton":"AboutComp_divButton__X2y-q"};